import React from "react";
import styled from "styled-components";

import { PADDING } from "styles";

import { ComponentLoader } from "../../loader";

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: ${PADDING.default};
  display: flex;
  flex-direction: column;
`;

export const CommonPageLayout = ({
  loading,
  children,
  containerStyle,
}: React.PropsWithChildren<{
  loading?: boolean;
  containerStyle?: React.CSSProperties;
}>) => {
  return (
    <ComponentLoader loading={loading || false}>
      <Container style={containerStyle}>{children}</Container>
    </ComponentLoader>
  );
};
